import React, { useState } from 'react';
import './css/Contact.css'; // Existing page styles
import './css/KirnavaliDetails.css'; // New dedicated styles for pathway map

// Reusing standalone, modular layout components
import Navbar from './components/Navbar';
import Newsletter from './components/NewsLetter';
import Footer from './components/Footer';

// Reusing global hero and banner background assets
import contactHeroBg from '../images/HomeBgBanner.png';
import kirnavaliDetails from '../images/Banner2.png';

// Reusing pathway milestone images (can use sample banner/associate images)
import stepImg1 from '../images/aden1.png';
import stepImg2 from '../images/aden1.png';
import stepImg3 from '../images/aden1.png';
import stepImg4 from '../images/aden1.png';
import stepImg5 from '../images/aden1.png';
import stepImg6 from '../images/aden1.png';
import stepImg7 from '../images/aden1.png';
import stepImg8 from '../images/aden1.png';
import stepImg9 from '../images/aden1.png';
import stepImg10 from '../images/aden1.png';
import stepImg11 from '../images/aden1.png';
import stepImg12 from '../images/aden1.png';
import stepImg13 from '../images/aden1.png';
import stepImg14 from '../images/aden1.png';

// Import your custom images here at the top
import featureSectionBg from '../images/Banner5.png'; // New Background Import

// Slide-Specific Image Imports
import featureLeftImg1 from '../images/carousel-1-updated.png';
import featureLeftImg2 from '../images/carousel-2-updated.png';
import featureLeftImg3 from '../images/carousel-3-updated.png';

import {
    FaChevronLeft,
    FaChevronRight,
    FaMicrochip,
    FaShieldAlt,
    FaBolt,
    FaLayerGroup,
    FaCode,
    FaServer,
    FaCloud
} from 'react-icons/fa';

function KirnavaliDetails() {
    const [activeStep, setActiveStep] = useState(null);

    // 14 Pathway Stops Data with images, larger headings, and sub-descriptions
    const pathwaySteps = [
        {
            id: 1,
            title: "Registration",
            subdesc: "Submit details & verify profile eligibility.",
            points: ["Online form submission", "Basic eligibility verification", "Student profile creation"],
            position: { top: "20%", left: "6%" },
            img: stepImg1
        },
        {
            id: 2,
            title: "Welcome Kit",
            subdesc: "Unlock portal credentials and resources.",
            points: ["Digital handbook access", "Portal login credentials", "Sample mock papers unlocked"],
            position: { top: "45%", left: "11%" },
            img: stepImg2
        },
        {
            id: 3,
            title: "Orientation",
            subdesc: "Attend live introductory webinars.",
            points: ["Live introductory webinar", "Syllabus briefing session", "Q&A with academic mentors"],
            position: { top: "72%", left: "16%" },
            img: stepImg3
        },
        {
            id: 4,
            title: "Warm-up Test",
            subdesc: "Take low-stakes diagnostic quizzes.",
            points: ["Low-stakes diagnostic quiz", "Identify preliminary strengths", "Customized study recommendations"],
            position: { top: "82%", left: "26%" },
            img: stepImg4
        },
        {
            id: 5,
            title: "Practice Drills",
            subdesc: "Build core skills via AI modules.",
            points: ["Topic-wise daily modules", "AI-driven adaptive practice", "Performance speed tracking"],
            position: { top: "62%", left: "30%" },
            img: stepImg5
        },
        {
            id: 6,
            title: "Level 1 Prelims",
            subdesc: "Face nationwide online tests.",
            points: ["Nationwide online test window", "Proctored assessment setup", "Instant preliminary score card"],
            position: { top: "36%", left: "28%" },
            img: stepImg6
        },
        {
            id: 7,
            title: "Result Analysis",
            subdesc: "Review accuracy & percentile reports.",
            points: ["Detailed percentile report", "Topic-wise accuracy check", "Peer comparative metrics"],
            position: { top: "18%", left: "36%" },
            img: stepImg7
        },
        {
            id: 8,
            title: "Bootcamp",
            subdesc: "Join expert masterclasses.",
            points: ["Intensive problem-solving sessions", "Time management workshops", "Advanced concepts review"],
            position: { top: "22%", left: "48%" },
            img: stepImg8
        },
        {
            id: 9,
            title: "Mock Mains",
            subdesc: "Simulate full-length papers.",
            points: ["Full-length exam simulations", "Strict environment testing", "Detailed post-mock debriefs"],
            position: { top: "46%", left: "52%" },
            img: stepImg9
        },
        {
            id: 10,
            title: "Level 2 Semifinals",
            subdesc: "Clear advanced test filters.",
            points: ["Challenging analytical test", "Top tier ranking filter", "Shortlisting regional toppers"],
            position: { top: "70%", left: "50%" },
            img: stepImg10
        },
        {
            id: 11,
            title: "Mentorship",
            subdesc: "Get direct expert guidance.",
            points: ["Direct feedback from experts", "Personalized strategy refinement", "Mental preparedness coaching"],
            position: { top: "84%", left: "62%" },
            img: stepImg11
        },
        {
            id: 12,
            title: "Grand Finale",
            subdesc: "Compete live nationwide.",
            points: ["Live national-level event", "Complex problem sets", "Top competitor face-off"],
            position: { top: "64%", left: "73%" },
            img: stepImg12
        },
        {
            id: 13,
            title: "Audit & Verify",
            subdesc: "Undergo rigorous score audits.",
            points: ["Panel verification of scores", "Anti-cheat audit logs", "Final ranking consensus"],
            position: { top: "40%", left: "78%" },
            img: stepImg13
        },
        {
            id: 14,
            title: "Awards & Honors",
            subdesc: "Celebrate at grand ceremony.",
            points: ["Grand felicitation ceremony", "Scholarships and trophies", "Future accelerator entry"],
            position: { top: "22%", left: "89%" },
            img: stepImg14
        }
    ];

    // 1. Dynamic Slide Content Dataset Array
    // const featureSlides = [
    //     {
    //         id: 1,
    //         miniTag: "System Integrations",
    //         heading: "Engineered For Ultra High Performance",
    //         description: "We build modular, predictable structures designed to scale elegantly under intense production workloads while strictly protecting visual specificity.",
    //         image: featureLeftImg1,
    //         pointers: [
    //             { icon: <FaMicrochip />, text: "Advanced multi-threaded rendering architectures" }, // Swapped FaCpu for FaMicrochip
    //             { icon: <FaShieldAlt />, text: "Strict design-token sandbox sandboxing layout layers" },
    //             { icon: <FaBolt />, text: "Sub-millisecond hydration cycles using localized modular states" }
    //         ]
    //     },
    //     {
    //         id: 2,
    //         miniTag: "Component Security",
    //         heading: "Zero Leak Layout Architecture",
    //         description: "Eliminate framework cascade pollution entirely with our strict encapsulation methodologies, preventing unwanted global overrides.",
    //         image: featureLeftImg2,
    //         pointers: [
    //             { icon: <FaLayerGroup />, text: "Highly structured CSS tree hierarchies" },
    //             { icon: <FaCode />, text: "Modular UI components optimized for heavy reuse" },
    //             { icon: <FaShieldAlt />, text: "Automatic vendor pre-fixes built right into compilation pipelines" }
    //         ]
    //     },
    //     {
    //         id: 3,
    //         miniTag: "Cloud Deployment",
    //         heading: "Global Edge Infrastructure Acceleration",
    //         description: "Distribute production bundles globally onto edge node clusters to minimize layout latency and optimize cross-continental loading footprints.",
    //         image: featureLeftImg3,
    //         pointers: [
    //             { icon: <FaCloud />, text: "Localized geographic static-site distribution arrays" }, // Swapped FaCloudRocket for FaCloud
    //             { icon: <FaBolt />, text: "Pre-rendered critical-path style injections" },
    //             { icon: <FaServer />, text: "Compression methods running on smart proxy networks" } // Swapped FaCpu for FaServer
    //         ]
    //     }
    // ];

    const featureSlides = [
        { id: 1, image: featureLeftImg1 },
        { id: 2, image: featureLeftImg2 },
        { id: 3, image: featureLeftImg3 }
    ];

    // 2. Active Slide Tracking State
    const [currentSlide, setCurrentSlide] = useState(0);

    const handleNext = () => {
        setCurrentSlide((prev) => (prev === featureSlides.length - 1 ? 0 : prev + 1));
    };

    const handlePrev = () => {
        setCurrentSlide((prev) => (prev === 0 ? featureSlides.length - 1 : prev - 1));
    };

    return (
        <div className="contact-page-wrapper">

            {/* 1. Header Hero Section with integrated clean Navbar */}
            <section
                className="contact-hero-section"
                style={{ backgroundImage: `url(${contactHeroBg})` }}
            >
                <Navbar />
            </section>

            {/* 2. Kirnavali Pathway Map Challenge Section */}
            <section className="kirnavali-pathway-section py-5" style={{ backgroundImage: `url(${kirnavaliDetails})` }}>
                <div className="container text-center my-4">
                    <span className="badge px-3 py-1 rounded-pill fw-bold mb-2 shadow-sm" style={{ backgroundColor: '#207AB4', color: '#ffffff' }}>
                        Roadmap to Glory
                    </span>
                    <h2 className="fw-bold display-6 mb-3" style={{ color: '#207AB4' }}>The Kirnavali Challenge Pathway</h2>
                    <p className="text-muted mx-auto mb-5" style={{ maxWidth: '650px' }}>
                        Navigate through our carefully curated 14-step journey designed to test, elevate, and celebrate academic excellence. Hover over each stop to explore details.
                    </p>

                    {/* Pathway Container Map */}
                    <div className="pathway-map-container position-relative mx-auto">
                        
                        {/* SVG Winding Path Connecting Line matching coordinates cleanly */}
                        <svg className="pathway-svg-line" viewBox="0 0 1000 600" preserveAspectRatio="none">
                            <path
                                d="M 60,120 C 110,270 110,430 160,500 C 210,570 260,550 300,380 C 340,210 360,110 480,130 C 600,150 520,380 500,500 C 480,620 620,620 730,420 C 840,220 840,180 890,130"
                                fill="none"
                                stroke="#207AB4"
                                strokeWidth="4"
                                strokeDasharray="8 8"
                                className="pathway-animated-dash"
                            />
                        </svg>

                        {/* 14 Interactive Stops */}
                        {pathwaySteps.map((step) => (
                            <div
                                key={step.id}
                                className={`pathway-pointer-node ${activeStep === step.id ? 'active-node' : ''}`}
                                style={{ top: step.position.top, left: step.position.left }}
                                onMouseEnter={() => setActiveStep(step.id)}
                                onMouseLeave={() => setActiveStep(null)}
                            >
                                <div className="pointer-pin">
                                    <span className="pointer-number">{step.id}</span>
                                </div>

                                {/* Clean Label Card below pointer with larger fonts */}
                                <div className="pointer-label-card text-start shadow-sm">
                                    <h6 className="fw-bold text-dark mb-1">{step.title}</h6>
                                    <p className="text-muted mb-0">{step.subdesc}</p>
                                </div>

                                {/* Expanded Tooltip Card with Image, Larger Heading, and Subtext */}
                                <div className="pathway-tooltip shadow-lg">
                                    <div className="tooltip-img-wrapper mb-2 rounded-2 overflow-hidden">
                                        <img src={step.img} alt={step.title} className="w-100 h-100 object-fit-cover" />
                                    </div>
                                    <h5 className="fw-bold text-primary mb-1">{step.title}</h5>
                                    <p className="text-dark fw-semibold mb-2">{step.subdesc}</p>
                                    <ul className="list-unstyled text-start text-secondary mb-0">
                                        {step.points.map((pt, i) => (
                                            <li key={i} className="mb-1 d-flex align-items-center">
                                                <span className="me-2 text-warning fw-bold">•</span> {pt}
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

             {/* 3. High-Impact Full-Width Feature Section */}
            {/* <section className="about-feature-bg-section" style={{ backgroundImage: `url(${featureSectionBg})` }}>
                <div className="container">
                    <div className="about-slider-viewport">
                        <div
                            className="about-slider-track"
                            style={{ transform: `translateX(-${currentSlide * 100}%)` }}
                        >
                            {featureSlides.map((slide) => (
                                <div className="about-split-card-slide" key={slide.id}>
                                    <div className="row g-0 align-items-center h-100 w-100">
                                        <div className="col-lg-5 text-center p-4 p-lg-5 feature-img-col feature-divider-right">
                                            <img
                                                src={slide.image}
                                                alt={slide.heading}
                                                className="img-fluid split-card-img"
                                            />
                                        </div>

                                        <div className="col-lg-7 p-4 p-lg-5 feature-text-col">
                                            <span className="feature-mini-tag">{slide.miniTag}</span>
                                            <h2 className="feature-card-heading">{slide.heading}</h2>
                                            <div className="feature-zigzag mb-4"></div>
                                            <p className="feature-card-desc">{slide.description}</p>

                                            <ul className="feature-pointers-list">
                                                {slide.pointers.map((pointer, pIdx) => (
                                                    <li key={pIdx}>
                                                        <div className="pointer-icon-wrapper">
                                                            {pointer.icon}
                                                        </div>
                                                        <span className="pointer-text">{pointer.text}</span>
                                                    </li>
                                                ))}
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>

                    <div className="slider-navigation-row">
                        <button className="slider-action-btn" onClick={handlePrev} aria-label="Previous Slide">
                            <FaChevronLeft className="btn-icon" />
                        </button>
                        <button className="slider-action-btn" onClick={handleNext} aria-label="Next Slide">
                            <FaChevronRight className="btn-icon" />
                        </button>
                    </div>
                </div>
            </section> */}

            <section className="about-feature-bg-section py-5" style={{ backgroundImage: `url(${featureSectionBg})` }}>
                <div className="container">
                    <div className="about-slider-viewport mx-auto" style={{ maxWidth: '1080px', overflow: 'hidden', borderRadius: '12px' }}>
                        <div
                            className="about-slider-track d-flex"
                            style={{ transform: `translateX(-${currentSlide * 100}%)`, transition: 'transform 0.5s ease-in-out' }}
                        >
                            {featureSlides.map((slide) => (
                                <div className="about-split-card-slide w-100 flex-shrink-0" key={slide.id}>
                                    <div className="image-only-slide-container w-100 bg-dark" >
                                        <img
                                            src={slide.image}
                                            alt="Slide Showcase"
                                            className="w-100 shadow-sm rounded-3"
                                            style={{ objectFit: 'contain' }}
                                        />
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>

                    <div className="slider-navigation-row">
                        <button className="slider-action-btn" onClick={handlePrev} aria-label="Previous Slide">
                            <FaChevronLeft className="btn-icon" />
                        </button>
                        <button className="slider-action-btn" onClick={handleNext} aria-label="Next Slide">
                            <FaChevronRight className="btn-icon" />
                        </button>
                    </div>
                </div>
            </section>

            {/* 3. Reusable Global Bottom Components */}
            <Newsletter />
            <Footer />

        </div>
    );
}

export default KirnavaliDetails;